import React, { useEffect } from "react";
import { IndexRoutes } from "./routes/IndexRoutes";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./store";
import { useAuth } from "react-oidc-context";
import {
  agregarAvatar,
  agregarToken,
  setRoles,
  setUsuario,
} from "./features/ui/uiSlice";
import { useLazyGetPermisosQuery } from "./services/docs";

const App: React.FC = () => {
  const { token, usuario } = useSelector((state: RootState) => state.ui);
  const [getPermisos, { data, isLoading }] = useLazyGetPermisosQuery();
  const dispatch = useDispatch();
  const auth = useAuth();

  useEffect(() => {
    if (auth.isLoading) return;
    if (!auth.isAuthenticated) {
      auth.signinRedirect();
    } else {
      console.log(auth.user);
      dispatch(agregarToken(auth.user.access_token));
      dispatch(setUsuario(auth.user.profile));
      getMenu();
    }
  }, [auth]);

  const getMenu = async () => {
    const d = await getPermisos().unwrap();
    if (d) {
      dispatch(agregarAvatar(d.fc_avatar));
      dispatch(setRoles(d.roles));
    }
  };
  if (token) return <IndexRoutes />;
};

export default App;
